"use client"
import React, { useContext, useState } from 'react';
// import { Sons } from '../../context/theme';
import { ThemeContext } from "../../context/ThemeContextProvider";
import { CustomerContext } from "../../context/CustomerContextProvider";
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/Drawer';
import Minicart from "../../layout/minicart/renderer";
import { getBaseUrl } from "../../utils/UrlManager";
import Link from 'next/link'
import Image from 'next/image'
import sonsLogoWhite from '../../../../public/images/menu/sons_logo_wht.svg';
import { useRouter } from 'next/navigation';

export default function Menu () {
    const context = useContext(ThemeContext);
    const customerContext = useContext(CustomerContext);
    const baseUrl = getBaseUrl();
    const router = useRouter();
    const [imageClass, setImageClass] = useState('m_contact_us');
    const [burgerClass, setBurgerClass] = useState('');

    const [state, setState] = React.useState({
        top: false
    });
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ [anchor]: open });
        let burger = burgerClass;
        if (burger !== '') {
            burger = '';
        } else {
            burger = 'open-burger'
        }
        // add slight delay to allow slider to come down and show completed animation
        setTimeout( () => {
            setBurgerClass(burger);
        }, 100 );

    };

    function handleLinkHover(title)  {
        let val = title.toLowerCase().replaceAll(' ', '_');
        setImageClass( ( "m_" + val ));
    }

    function handleAccountMenuLinks(route) {
        setState({ ['top']: false });
        customerContext.showPageLoader(true);
        router.push(route);

    }

    function redirectToHomepage() {
        window.location.href = getBaseUrl();
    }

    return <React.Fragment key={'top'}>

            <div className="menu-header-open menu" onClick={toggleDrawer('top', true)}>
                <div className="menu__pill">
                    <span className="desktop">Menu</span>
                    <span className={ "mobile " + burgerClass} id="burger">
                        <span id="burgerTop" className={ "burgerLineTop" + ( burgerClass !== '' ? ' burgerLineTopAnimation' : '' ) }></span>
                        <span id="burgerCenter" className={ "burgerLineCenter" + ( burgerClass !== '' ? ' burgerLineCenterAnimation' : '' )  }></span>
                        <span id="burgerBottom" className={ "burgerLineBottom" + ( burgerClass !== '' ? ' burgerLineBottomAnimation' : '' )  }></span>
                    </span>
                </div>
            </div>
        <SwipeableDrawer
            anchor={'top'}
            open={state['top']}
            // elevation={32}
            onClose={ toggleDrawer('top', false) }
            className={'sons-mui-drawer-container'}
        >
            <div id="menu-wrapper" className="menu-wrapper">

                <div className="menu__top">
                    <div className="menu left">
                        <div className="menu__pill" onClick={ toggleDrawer('top', false) }>
                            <span className="desktop">Close</span>
                            <span className={ "mobile " + burgerClass} id="burger">
                                <span id="burgerTop" className={ "burgerLineTop" + ( burgerClass !== '' ? ' burgerLineTopAnimation' : '' ) } ></span>
                                <span id="burgerCenter" className={ "burgerLineCenter" + ( burgerClass !== '' ? ' burgerLineCenterAnimation' : '' )  }></span>
                                <span id="burgerBottom" className={ "burgerLineBottom" + ( burgerClass !== '' ? ' burgerLineBottomAnimation' : '' )  } ></span>
                            </span>
                        </div>
                    </div>
                    { (typeof window !== "undefined" && !window.location.href.includes('/customer/account')) &&
                        <div className="menu right">
                            <Minicart/>
                        </div>
                    }
                </div>


                <div className="menu__container">
                    <div className={ "container__image " + imageClass }></div>
                    <div className="container__menu">
                        <div className="menu__items">
                            <div className="items__logo">
                                <Link href={ baseUrl }>
                                    <Image src={ sonsLogoWhite } width={ 92 } height={ 28 } alt="Sons Logo" />
                                </Link>
                            </div>
                            { /* Customer Account Menu */ }
                            { (typeof window !== "undefined" && window.location.href.includes('/customer/account')) &&
                                <>
                                    <div className="items__links">
                                        <span className="links__title">
                                            { "Account" }
                                        </span>
                                        <div
                                            onMouseEnter={ () => handleLinkHover('Homepage') }
                                            className="links__main">
                                            <span
                                                onClick={ redirectToHomepage }
                                                >
                                                { "Homepage" }
                                            </span>
                                        </div>
                                        <div
                                            onMouseEnter={ () => handleLinkHover('dashboard') }
                                            className="links__main">
                                            <span
                                                onClick={ () => handleAccountMenuLinks("/customer/account/dashboard") }
                                                >
                                                { "Dashboard" }
                                            </span>
                                        </div>
                                        <div
                                            onMouseEnter={ () => handleLinkHover('account_details') }
                                            className="links__main">
                                            <span
                                                onClick={ () => handleAccountMenuLinks("/customer/account/details") }
                                                >
                                                { "Account Details" }
                                            </span>
                                        </div>
                                    </div>
                                    <div className="items__links">
                                        <span className="links__title">
                                            { "Customer Support" }
                                        </span>
                                        <div
                                            // onMouseEnter={ () => handleLinkHover('helloSons') }
                                            className="links__main">
                                            <Link href="mailto:hello@sons.co.uk">
                                                { "hello@sons.co.uk" }
                                            </Link>
                                        </div>
                                        <div
                                            // onMouseEnter={ () => handleLinkHover('telephone') }
                                            className="links__main">
                                            <Link href="tel:02081542524">
                                                { "02081542524" }
                                            </Link>
                                        </div>
                                        <div
                                            // onMouseEnter={ () => handleLinkHover('whatsapp') }
                                            className="links__main">
                                            <Link href="thttps://wa.me/442081542524">
                                                { "Whatsapp" }
                                            </Link>
                                        </div>
                                        <div className="links__main m_log_out">
                                            <Link href={ baseUrl + "account/logout" }>Logout</Link>
                                        </div>
                                    </div>
                                </>
                            }
                            { /* Non-customer Account Menu */ }
                            { (typeof window !== "undefined" && !window.location.href.includes('/customer/account')) &&
                                <>
                                    { (typeof context !== "undefined" && context?.menuItems?.length > 0) &&
                                        <>
                                            { context.menuItems.map( (item, index) => {

                                                return (
                                                    <div key={ "menu_link_container_" + index }
                                                        className="items__links">
                                                        <span className="links__title">
                                                            { item.title }
                                                        </span>
                                                        { item.items.map( (link, indx) => (
                                                            <div
                                                                key={ "menu_link_link_" + indx }
                                                                className="links__main"
                                                                onMouseEnter={ () => handleLinkHover(link.title) }
                                                            >
                                                                <Link href={ link.url }>
                                                                    { link.title }
                                                                </Link>
                                                            </div>
                                                        ))}

                                                        { (item.title === 'Your Sons') &&
                                                            <div className="links__main m_log_out">
                                                                <Link href={ baseUrl + "account/logout" }>Logout</Link>
                                                            </div>
                                                        }
                                                    </div>
                                                );
                                            } ) }
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </SwipeableDrawer>
    </React.Fragment>;
}